module.exports = __webpack_public_path__ + "img/royalFlush.73f0133e.png";